import React from 'react';
import { Layout } from '../components/Layout';
import { Card } from '../components/ui/Card';
import { useTranslation } from '../i18n';
export function CookiePolicyPage() {
  const {
    t
  } = useTranslation();
  return <Layout data-id="element-1589">
      <section className="bg-teal-900 text-white py-16" data-id="element-1590">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-1591">
          <h1 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-1592">Cookie Policy</h1>
          <p className="text-teal-100" data-id="element-1593">Last updated: 5 February 2026</p>
        </div>
      </section>

      <section className="py-16 bg-gray-50" data-id="element-1594">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1595">
          <Card className="p-8 md:p-12 prose prose-teal max-w-none" data-id="element-1596">
            <p className="lead" data-id="element-1597">
              This Cookie Policy explains how Dentico Dental Clinic Ltd uses
              cookies and similar technologies on denticoclinic.co.uk.
            </p>

            <h3 data-id="element-1598">We use:</h3>
            <ul className="space-y-2" data-id="element-1599">
              <li data-id="element-1600">
                <strong data-id="element-1601">Strictly necessary cookies</strong> — required for core
                site functionality.
              </li>
              <li data-id="element-1602">
                <strong data-id="element-1603">Analytics cookies</strong> — to understand website
                performance and improve user experience (used with consent where
                required).
              </li>
              <li data-id="element-1604">
                <strong data-id="element-1605">Functional cookies</strong> — to remember preferences
                such as language/settings.
              </li>
              <li data-id="element-1606">
                <strong data-id="element-1607">Marketing cookies</strong> (if enabled) — to measure
                campaign performance.
              </li>
            </ul>

            <h3 data-id="element-1608">Managing Cookies</h3>
            <p data-id="element-1609">
              You can manage cookie preferences in our cookie banner/settings
              and in your browser.
            </p>
            <p data-id="element-1610">
              Some third-party services (e.g. analytics/maps/booking tools) may
              set cookies under their own policies.
            </p>

            <div className="border-t border-gray-200 pt-8 mt-8" data-id="element-1611">
              <p data-id="element-1612">
                Contact:{' '}
                <a href="mailto:info@denticoclinic.co.uk" className="text-teal-600 font-medium hover:underline" data-id="element-1613">
                  info@denticoclinic.co.uk
                </a>
              </p>
            </div>
          </Card>
        </div>
      </section>
    </Layout>;
}